import React from 'react';

export function CommentariesModalPlaceholder() {
  return (
    <div className="commentaries-placeholder">
      <div className="animated-background">
        <div className="background-masker title-bottom" />
      </div>
    </div>
  );
}
